import { useSelector } from 'react-redux';
import logoGea from '../../../assets/images/logo-gea.png';

export function LogosFooter() {
  const detalle = useSelector((state) => state.applicationState.templateData.footer.detalle);

  const logos = (detalle && Array.isArray(detalle))
    ? detalle.filter((detalle) => detalle.categoria?.nombre === 'logos-institucionales')
    : [];
  const renderLogos =
    logos &&
    logos.map((logo) =>
      logo.url ? (
        <a
          href={logo.url.startsWith('http') ? logo.url : `https://${logo.url}`}
          className='footer-mb__column__footer__link'
          style={{ width: 'fit-content' }}
          key={logo.id}
          rel='noreferrer'
          target='_blank'

        >
          <img
            alt={logo.tipoEnlace?.nombre}
            className='footer-mb__column__footer__link__img'
            key={logo.tipoEnlace?.nombre}
            src={logo.valor}
          />
        </a>
      ) : (
        <img
          alt={logo.tipoEnlace?.nombre}
          className='footer-mb__column__footer__img'
          key={logo.id}
          src={logo.valor}
        />
      )
    );

  return (
    <>
      <img
        alt='GEA'
        className='footer-mb__column__footer__img'
        src={logoGea}
      />
      {renderLogos}
    </>
  );
}
